<template>
  <div id="Container">
    <Banner/>
    <!-- <a-Row :gutter="24" class="Containers" type="flex" justify="space-around" align="middle">
      <a-col :xs="24" :sm="12" :md="12" :lg="12" v-for="(item,index) in moreGame" :key="index">
        <div class="moreGame" @click="gameDetail(item)">
          <img :src="item.propImg" alt="图片">
          <p class="gameName">{{item.gameName}}</p>
          <p class="info">{{item.info}}</p>
        </div>
        <br class="brs">
      </a-col>
    </a-Row> -->
    
    <div class="detailInfo" :class="{'detailInfoLr':noRole}">
      <img class="jqRoleR"  :src="jqInfo.gameRoleR" alt>
      <div class="jq-logo">
        <img :src="jqInfo.gameLogo" alt="街球logo">
      </div>
      <div class="introduce">
        <div class="introduceTitle">
          <img :src="gameTitle" alt="标题1">
        </div>
        <div class="introduceText">{{jqInfo.gameInfoText}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Row, Col } from "ant-design-vue";
import Banner from "@/components/Common/Banner.vue";
export default {
  name: "Container",
  data() {
    return {
      moreGame: [
        {
          gameName: "街球艺术:3对3",
          info:
            "《街球艺术 3对3》是一款基于街头篮球打法的篮球竞技游戏。玩家（用户）在游戏中使用球员与其他玩家使用的球员按照街头篮球的规则进行篮球比赛，目的是与队友赢得比赛的胜利。",
          propImg: require("@/assets/index/jp_01.png")
        },
        // {
        //   gameName: "腹黑Q神传",
        //   info:
        //     "腹黑Q神传是一款回合制MMORPG游戏。产品有丰富的角色成长玩法和完善的社交玩法。游戏画面为清新时尚的卡通风格，容易为全年龄的、世界各地不同文化背景的玩家所接受。",
        //   propImg: require("@/assets/index/fh_01.png")
        // },
        // {
        //   gameName: "欢乐宠物店",
        //   info:
        //     "欢乐宠物店是一款新型网络社交游戏。此游戏主要内容为宠物店经营，面向为18-35岁用户。",
        //   propImg: require("@/assets/index/hl_01.png")
        // },
        // {
        //   gameName: "大家来找碴",
        //   info:
        //     "大家来找碴是一款类手机游戏，轻松、简单、有趣，面向广大轻度游戏用户。玩法规则、操作习惯及风格设计充分考虑设备特征及用户偏好。",
        //   propImg: require("@/assets/index/dj_01.png")
        // }
      ],
      jqInfo: {
        gameLogo: require("@/assets/jq/jq-logo.png"),
        gameRoleR: require("@/assets/jq/jq-role-r.png"),
        gameInfoText:
          "《街球艺术》是一款 3对3 真人竞技街球手游。游戏以“为竞技体验而生”为制作宗旨，采用美式街头风格，您将能在游戏里面跟着HIP-HOP音乐的节奏，用指尖去体验即时 3对3 篮球竞技的乐趣。"
      },
      gameTitle: require("@/assets/title.png"),
      noRole: false
    };
  },
  methods: {
    gameDetail(item) {
      this.$router.push({
        path: "/gameDetail",
        query: { gameName: item.gameName }
      });
    }
  },
  components: {
    aRow: Row,
    aCol: Col,
    Banner
  }
};
</script>
<style lang="stylus" scoped>
@import '../Common/common.styl';

#Container {
  width: 100%;

  .Containers {
    padding-top: 40px;
  }

  .moreGame {
    margin: 0 auto;
    cursor: pointer;
    background: #ffffff;
    border: 1px solid #d9d9d9;

    .gameName {
      font-size: 24px;
      font-weight: bold;
      padding: 10px 0px 10px 10px;
      border-bottom: 1px solid #d9d9d9;
    }

    .info {
      padding: 10px;
    }

    img {
      width: 100%;
    }
  }
}

@media screen and (max-width: 650px) {
  .moreGame {
    width: 100% !important;
    padding: 20px;
  }
  
  .brs {
    display: none;
  }
}

@media screen and (min-width: 650px) {
  .moreGame {
    box-shadow: 6px 6px 0px rgba(73, 118, 185, 0.32);
  }
}

@media screen and (max-width: 1080px) {
  .Containers {
    margin: 0 !important;
  }
}

@import './common.styl';

.detailInfo {
  width: 100%;
  text-align: center;
  paddingPage();
  position: relative;

  .jqRoleR {
    position: absolute;
    right: 0;
    bottom: 0px;
    max-width: 35%;
    width: 35%;
  }

  .jq-logo {
    img {
      max-width: 500px;
    }
  }

  .introduce {
    padding: 50px 0px 50px 0px;

    .introduceTitle {
      width: 54%; 
      img {
        width: 100%;
      }
    }

    .introduceText {
      width: 54%;
      text-align: left;
      text-indent: 34px;
      font-size: 18px;
      padding-top: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Container.vue